module.exports = __webpack_public_path__ + "img/RecentNew2.b3656309.jpg";